export default __webpack_public_path__ + "static/planning-development-accomplishment-2-0d0270e74b57ad2b7241eb839e6d5cdf.webp";